// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "app-do-joaozao.firebaseapp.com",
  "projectId": "app-do-joaozao",
  "storageBucket": "app-do-joaozao.appspot.com",
  "messagingSenderId": "763280795503",
  "appId": "1:763280795503:web:2b65a4d94c864041ee6a9a",
  "measurementId": "G-W9QCXCC793",
  "apiKey": "AIzaSyBZCcdRgjZAwVVROOtTmWHjEouuSNO8dBg"
};
